"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var queryString = require("query-string");
var course_1 = require("../../types/course");
var evaluation_1 = require("../../types/evaluation");
var apiConfig_1 = require("./apiConfig");
/**
 * 聪明派API客户端
 *
 * @class ApiClient
 */
var EvaluationApiClient = /** @class */ (function (_super) {
    __extends(EvaluationApiClient, _super);
    function EvaluationApiClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 获取报告的接口
     *
     * @returns {Promise<Evaluation>}
     * @memberof ApiClient
     */
    // 传参数返回指定enrollment的evaluations,默认返回所有
    EvaluationApiClient.prototype.getEvaluationDetail = function (enrollmentIds) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = EvaluationApiClient.API_BASE_URL + "/enrollments/evaluations";
                        if (enrollmentIds) {
                            url = EvaluationApiClient.API_BASE_URL + "/enrollments/evaluations?enrollmentIds=" + enrollmentIds;
                        }
                        return [4 /*yield*/, this.requestAdaptor({ url: url, method: 'GET' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    EvaluationApiClient.prototype.getTodayReports = function (serialIds) {
        if (serialIds === void 0) { serialIds = []; }
        return __awaiter(this, void 0, void 0, function () {
            var serialIdsQueryString, url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        serialIdsQueryString = queryString.stringify({ serialIds: serialIds });
                        url = EvaluationApiClient.API_BASE_URL + "/evaluation/today" + (serialIdsQueryString && "?" + serialIdsQueryString);
                        return [4 /*yield*/, this.requestAdaptor({ url: url, method: 'GET' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    EvaluationApiClient.prototype.getAccumulativeReport = function (serialIds) {
        if (serialIds === void 0) { serialIds = []; }
        return __awaiter(this, void 0, void 0, function () {
            var serialIdsQueryString, url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        serialIdsQueryString = queryString.stringify({ serialIds: serialIds });
                        url = EvaluationApiClient.API_BASE_URL + "/evaluation/accumulative" + (serialIdsQueryString && "?" + serialIdsQueryString);
                        return [4 /*yield*/, this.requestAdaptor({ url: url, method: 'GET' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    EvaluationApiClient.prototype.getTodayOverviewData = function (serialIds) {
        if (serialIds === void 0) { serialIds = []; }
        return __awaiter(this, void 0, void 0, function () {
            var serialIdsQueryString, url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        serialIdsQueryString = queryString.stringify({ serialIds: serialIds });
                        url = EvaluationApiClient.API_BASE_URL + "/evaluation/todayOverview" + (serialIdsQueryString && "?" + serialIdsQueryString);
                        return [4 /*yield*/, this.requestAdaptor({ url: url, method: 'GET' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    EvaluationApiClient.prototype.getReportsByLessonId = function (lessonId) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = EvaluationApiClient.API_BASE_URL + "/evaluation/lesson/" + lessonId;
                        return [4 /*yield*/, this.requestAdaptor({ url: url, method: 'GET' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    EvaluationApiClient.prototype.getGrowthShareData = function (uuid, serialIds, lessonId) {
        return __awaiter(this, void 0, void 0, function () {
            var serialIdsQueryString, url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        serialIdsQueryString = queryString.stringify({ serialIds: serialIds, lessonId: lessonId });
                        url = EvaluationApiClient.API_BASE_URL + "/share/growth/" + uuid + "?" + serialIdsQueryString;
                        return [4 /*yield*/, this.requestAdaptor({ url: url, method: 'GET' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    EvaluationApiClient.prototype.getCertificateShareData = function (uuid, serialIds) {
        return __awaiter(this, void 0, void 0, function () {
            var query, url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = queryString.stringify({ serialIds: serialIds });
                        url = EvaluationApiClient.API_BASE_URL + "/share/certificate/" + uuid + "?" + query;
                        return [4 /*yield*/, this.requestAdaptor({ url: url, method: 'GET' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    EvaluationApiClient.prototype.getKnowledgePointAccuracy = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var options, query, url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        options = { criteriaTypes: evaluation_1.QuestionCriteriaType.ACCURACY };
                        query = queryString.stringify(options);
                        url = EvaluationApiClient.API_BASE_URL + "/evaluation/" + id + "/statistics/" + course_1.TeachingPointType.KNOWLEDGE_POINT + "?" + query;
                        // TODO response type assert is required, remove console.warn after declared type
                        console.warn("Response type assert is required, path: /auth/wechat");
                        return [4 /*yield*/, this.requestAdaptor({ url: url, method: 'GET' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    /**
     * 查询是否有学习记录
     *
     * @param {string[]} skuGroupNames
     * @returns
     * @memberof ApiClient
     */
    EvaluationApiClient.prototype.getUserCompletedCourses = function (serialIds) {
        return __awaiter(this, void 0, void 0, function () {
            var query, url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = queryString.stringify({ serialIds: serialIds });
                        url = EvaluationApiClient.API_BASE_URL + "/enrollments/courses/complete/status?" + query;
                        return [4 /*yield*/, this.requestAdaptor({ url: url, method: 'GET' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    return EvaluationApiClient;
}(apiConfig_1.ApiConfig));
exports.EvaluationApiClient = EvaluationApiClient;
//# sourceMappingURL=evaluation.js.map


//////////////////
// WEBPACK FOOTER
// ../core/dist/src/services/api/evaluation.js
// module id = 1030
// module chunks = 0